import axios from "axios";
import Config from "../../../config/index";
import { CREATE_DURABILITY_FAILURE, CREATE_DURABILITY_REQUEST, CREATE_DURABILITY_SUCCESS, EDIT_DURABILITY_FAILURE, EDIT_DURABILITY_REQUEST, EDIT_DURABILITY_SUCCESS, GET_DELETE_DURABILITY_FAILURE, GET_DELETE_DURABILITY_REQUEST, GET_DELETE_DURABILITY_SUCCESS, GET_DPP_DURABILITY_FAILURE, GET_DPP_DURABILITY_REQUEST, GET_DPP_DURABILITY_SUCCESS, UPLOAD_DURABILITY_FAILURE, UPLOAD_DURABILITY_REQUEST, UPLOAD_DURABILITY_SUCCESS, UPLOAD_RM_FAILURE, UPLOAD_RM_REQUEST, UPLOAD_RM_SUCCESS } from "./durabilityTypes";


let baseUrl = Config.baseUrl;
let baseUrlFileUploadTemp = Config.baseUrlFileUploadTemp;


const getDppDurabilityRequest = () => {
  return {
    type: GET_DPP_DURABILITY_REQUEST,
  };
};

const getDppDurabilitySuccess = (payload) => {
  return {
    type: GET_DPP_DURABILITY_SUCCESS,
    payload: payload,
  };
};

const getDppDurabilityFailure = (error) => {
  return {
    type: GET_DPP_DURABILITY_FAILURE,
    payload: error,
  };
};
const getDppDurability = (dppId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(getDppDurabilityRequest());

    let url;

    // If dppId is provided → fetch specific durability data
    if (dppId) {
      url = `${baseUrl}/dpp/get_durability_bydpp?dppId=${dppId}`;
    } else {
      // If NO dppId → fetch all
      url = `${baseUrl}/dpp/get_durability`;
    }

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getDppDurabilitySuccess(response.data));
      })
      .catch((err) => {
        dispatch(getDppDurabilityFailure(err.message));
      });
  };
};

const deleteDurabilityRequest = () => {
  return {
    type: GET_DELETE_DURABILITY_REQUEST,
  };
};

const deleteDurabilitySuccess = (payload) => {
  return {
    type: GET_DELETE_DURABILITY_SUCCESS,
    payload: payload,
  };
};

const deleteDurabilityFaliure = (error) => {
  return {
    type: GET_DELETE_DURABILITY_FAILURE,
    payload: error,
  };
};

const deleteDurability = (docId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(deleteDurabilityRequest());
    // let url = `${baseUrl}/dpp/product_passport/delete?dppId=${dppId}`;

    let url = `${baseUrl}/dpp/delete_durability?durabilityId=${docId}`;
    // let url = `${baseUrl}/mvtmap?id=${productId}`;
    // let url = `/mvtmap?id=334`;
    return axios
      .delete(url, {}, headers)
      .then((response) => {
        dispatch(deleteDurabilitySuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(deleteDurabilityFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const createDurabilityRequest = () => {
  return {
    type: CREATE_DURABILITY_REQUEST,
  };
};

const createDurabilitySuccess = (payload) => {
  return {
    type: CREATE_DURABILITY_SUCCESS,
    payload: payload,
  };
};

const createDurabilityFailure = (error) => {
  return {
    type: CREATE_DURABILITY_FAILURE,
    payload: error,
  };
};

const createDurability = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(createDurabilityRequest());
    let url = `${baseUrl}/dpp/create_durability`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createDurabilitySuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createDurabilityFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const editDurabilityRequest = () => {
  return {
    type: EDIT_DURABILITY_REQUEST,
  };
};

const editDurabilitySuccess = (payload) => {
  return {
    type: EDIT_DURABILITY_SUCCESS,
    payload: payload,
  };
};

const editDurabilityFailure = (error) => {
  return {
    type: EDIT_DURABILITY_FAILURE,
    payload: error,
  };
};

const editDurability = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(editDurabilityRequest());
    let url = `${baseUrl}/dpp/update_durability`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(editDurabilitySuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(editDurabilityFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};


const uploadForDurabilityRequest = () => {
  return {
    type: UPLOAD_DURABILITY_REQUEST,
  };
};

const uploadForDurabilitySuccess = (payload) => {
  return {
    type: UPLOAD_DURABILITY_SUCCESS,
    payload: payload,
  };
};

const uploadForDurabilityFailure = (error) => {
  return {
    type: UPLOAD_DURABILITY_FAILURE,
    payload: error,
  };
};

const uploadForDurability = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(uploadForDurabilityRequest());
    let url = `${baseUrlFileUploadTemp}/dpp_durability/upload`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(uploadForDurabilitySuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(uploadForDurabilityFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};


const uploadForRmTraceabilityRequest = () => {
  return {
    type: UPLOAD_RM_REQUEST,
  };
};

const uploadForRmTraceabilitySuccess = (payload) => {
  return {
    type: UPLOAD_RM_SUCCESS,
    payload: payload,
  };
};

const uploadForRmTraceabilityFailure = (error) => {
  return {
    type: UPLOAD_RM_FAILURE,
    payload: error,
  };
};

const uploadForRmTraceability = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(uploadForRmTraceabilityRequest());
    let url = `${baseUrlFileUploadTemp}/dpp_rm/upload`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(uploadForRmTraceabilitySuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(uploadForRmTraceabilityFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};


export {
  getDppDurability,
  deleteDurability,
  createDurability,
    editDurability,
    uploadForDurability,
    uploadForRmTraceability

};
